<template>
  <div id="pdf-content" style="width: 100%; font-family: Arial, sans-serif">
    <div
      style="
        text-align: center;
        text-transform: uppercase;
        font-family: Arial, sans-serif;
      "
      :style="
        'margin-top: ' +
        (selectedLanguageType.languageType == 2
          ? ui_setting.headYEN
          : ui_setting.headYEN) +
        'px;font-size: ' +
        ui_setting.schoolFontSize +
        'pt'
      "
    >
      {{ _getTranslateTextLabel("schoolName") }}
    </div>
    <div
      v-if="_getTranslateTextLabel('subTitle')"
      style="text-align: center; font-family: Arial, sans-serif"
      :style="
        'margin-top: ' +
        (selectedLanguageType.languageType == 2
          ? ui_setting.subTitleYEN
          : ui_setting.subTitleY) +
        'px;font-size: ' +
        ui_setting.subTitleFontSize +
        'pt'
      "
    >
      <span
        v-if="selectedLanguageType.languageType == 3"
        style="font-weight: bold"
      >
        {{
          _convertToMB(
            _getTranslateTextLabel("subTitle")
              .replaceAll("$$diplomaPaperNumber$$", student.diplomaPaperNumber)
              .replaceAll(
                "$$diplomaDegree$$",
                _getDiplomaDegreeText(
                  student.xprofession.xprofessiondegree.shortName
                )
              )
          )
        }}
      </span>
      <span v-else>
        {{
          _getTranslateTextLabel("subTitle")
            .replaceAll("$$diplomaPaperNumber$$", student.diplomaPaperNumber)
            .replaceAll(
              "$$diplomaDegree$$",
              _getDiplomaDegreeText(
                student.xprofession.xprofessiondegree.shortName
              )
            )
        }}
      </span>
    </div>
    <div
      style="
        background-color: rosybrown;
        position: relative;
        top: 40.08px;
        font-family: Arial, sans-serif;
      "
      :style="
        'left:' +
        ui_setting.scoreTableX +
        'px; width:' +
        ui_setting.scoreTableWidth +
        'px'
      "
    >
      <table style="width: 100%">
        <tr style="display: flex; flex-direction: row">
          <td
            style="
              width: 33%;
              display: flex;
              align: start;
              padding-right: 19px !important;
              padding-left: 0;
            "
          >
            <table
              style="width: 100% !important; border-collapse: collapse"
              :style="
                'font-size: ' +
                (selectedLanguageType.languageType == 1
                  ? ui_setting.totalScoreFontSize + 'pt'
                  : selectedLanguageType.languageType == 2
                  ? ui_setting.totalScoreFontSizeEN + 'pt'
                  : selectedLanguageType.languageType == 3
                  ? ui_setting.totalScoreFontSizeMB + 'pt'
                  : '')
              "
            >
              <tr>
                <td class="text-start pa-0 ma-0">
                  {{ _getTranslateTextLabel("_lastName") }}
                </td>
                <td
                  class="text-start pa-0 ma-0"
                  style="font-weight: bold; text-transform: uppercase"
                >
                  {{ _getTranslateString("lastName") }}
                </td>
              </tr>
              <tr>
                <td class="text-start pa-0 ma-0">
                  {{ _getTranslateTextLabel("_firstName") }}:
                </td>
                <td
                  class="text-start pa-0 ma-0"
                  style="font-weight: bold; text-transform: uppercase"
                >
                  {{ _getTranslateString("firstName") }}
                </td>
              </tr>
              <tr>
                <td class="text-start pa-0 ma-0">
                  {{ _getTranslateTextLabel("_citizenID") }}:
                </td>
                <td
                  class="text-start text-uppercase pa-0 ma-0"
                  style="font-weight: bold; text-transform: uppercase"
                >
                  <span v-if="selectedLanguageType.languageType == 3">
                    {{ student.registerMB }}
                  </span>
                  <span v-else-if="selectedLanguageType.languageType == 2">
                    {{ student.registerEN }}
                  </span>
                  <span v-else>
                    {{ student.register }}
                  </span>
                </td>
              </tr>
            </table>
          </td>
          <td
            style="
              width: 33%;
              display: flex;
              align: start;
              padding-right: 19px !important;
              padding-left: 0;
            "
          >
            <table
              style="width: 100% !important; border-collapse: collapse"
              :style="
                'font-size: ' +
                (selectedLanguageType.languageType == 1
                  ? ui_setting.totalScoreFontSize + 'pt'
                  : selectedLanguageType.languageType == 2
                  ? ui_setting.totalScoreFontSizeEN + 'pt'
                  : selectedLanguageType.languageType == 3
                  ? ui_setting.totalScoreFontSizeMB + 'pt'
                  : '')
              "
            >
              <tr>
                <td style="padding: 0">
                  {{ _getTranslateTextLabel("_graduatedYear") }}:
                </td>
                <td style="padding: 0; font-weight: bold">
                  <span v-if="selectedLanguageType.languageType == 3">
                    {{ _convertToMB(new Date().getFullYear()) }}
                  </span>
                  <span v-else>{{ new Date().getFullYear() }}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 50%; padding: 0">
                  {{ _getTranslateTextLabel("_curriculumIndex") }}
                </td>
                <td
                  class="font-weight-bold text-start pa-0 ma-0"
                  style="font-weight: bold"
                >
                  <span
                    v-if="
                      student.xprofession &&
                      student.xprofession.xcurriculumIndex
                    "
                  >
                    <span
                      v-if="selectedLanguageType.languageType == 3"
                      style="font-weight: bold"
                    >
                      {{
                        _convertToMB(student.xprofession.xcurriculumIndex)
                      }}</span
                    >
                    <span v-else style="font-weight: bold">{{
                      student.xprofession.xcurriculumIndex
                    }}</span>
                  </span>
                  <span v-else class="red--text pa-0 ma-0">NOT F4OUND</span>
                </td>
              </tr>
              <tr>
                <td style="width: 50%; padding: 0">
                  {{ _getTranslateTextLabel("_curriculumName") }}:
                </td>
                <td
                  style="
                    text-transform: uppercase;
                    font-weight: bold;
                    padding: 0;
                  "
                >
                  <span
                    v-if="
                      student.xcurriculum &&
                      selectedLanguageType.languageType == 1
                    "
                  >
                    <span
                      :style="
                        'font-size:' + ui_setting.professionNameFontSize + 'pt'
                      "
                      >{{ student.xcurriculum.name }}</span
                    >
                  </span>
                  <span
                    v-else-if="
                      student.xcurriculum &&
                      selectedLanguageType.languageType == 2
                    "
                  >
                    <span
                      :style="
                        'font-size:' +
                        ui_setting.professionNameFontSizeEN +
                        'pt'
                      "
                      >{{ student.xcurriculum.nameEN }}</span
                    >
                  </span>
                  <span
                    v-else-if="
                      student.xcurriculum &&
                      selectedLanguageType.languageType == 3
                    "
                  >
                    <span
                      :style="
                        'font-size:' +
                        ui_setting.professionNameFontSizeMB +
                        'pt'
                      "
                      >{{ student.xcurriculum.nameMX }}</span
                    >
                  </span>
                </td>
              </tr>
            </table>
          </td>
          <td
            style="
              width: 33%;
              display: flex;
              align: start;
              padding-right: 19px !important;
              padding-left: 0;
            "
          >
            <table
              style="width: 100% !important; border-collapse: collapse"
              :style="
                'font-size: ' +
                (selectedLanguageType.languageType == 1
                  ? ui_setting.totalScoreFontSize + 'pt'
                  : selectedLanguageType.languageType == 2
                  ? ui_setting.totalScoreFontSizeEN + 'pt'
                  : selectedLanguageType.languageType == 3
                  ? ui_setting.totalScoreFontSizeMB + 'pt'
                  : '')
              "
            >
              <tr>
                <td class="text-start pa-0 ma-0">
                  {{ _getTranslateTextLabel("_issuedDate") }}:
                </td>
                <td style="font-weight: bold !important; padding: 0px">
                  {{ _getTranslateText("diplomIssuedDate") }}
                </td>
              </tr>
              <tr>
                <td class="text-start pa-0 ma-0">
                  {{ _getTranslateTextLabel("_registerNumber") }}:
                </td>
                <td class="font-weight-bold text-start pa-0 ma-0">
                  <span
                    v-if="selectedLanguageType.languageType == 3"
                    style="font-weight: bold"
                    >{{ _convertToMB(student.diplomaRegisterNumber) }}</span
                  >
                  <span v-else style="font-weight: bold">
                    {{ student.diplomaRegisterNumber }}
                  </span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div
      style="
        height: 415.748px;
        background-color: bisque;
        position: relative;
        top: 40.08px;
      "
      :style="
        'left:' +
        (selectedLanguageType.languageType == 1
          ? ui_setting.scoreTableX
          : selectedLanguageType.languageType == 2
          ? ui_setting.scoreTableXEN
          : selectedLanguageType.languageType == 3
          ? ui_setting.scoreTableXMB
          : '140') +
        'px; width:' +
        ui_setting.scoreTableWidth +
        'px'
      "
    >
      <template v-if="studentScores && studentScores.length > 0">
        <Table3Score
          :studentScores="studentScores"
          :curriculum="curriculum"
          :selectedLanguageType="selectedLanguageType"
          :showLessonCode="showLessonCode"
          :ui_setting="ui_setting"
          :allCredit="allCredit"
          :finalGPA="(allCreditPoints / allCredit).toFixed(2)"
          :diplomTopicText1="_getTranslateString('diplomPreText')"
          :diplomTopicText2="_getTranslateString('diplomWorkTitle')"
          :signatureText1="_getTranslateString('signatureText1')"
          :signatureText2="_getTranslateString('signatureText2')"
          :signatureName1="_getTranslateString('signatureName1')"
          :signatureName2="_getTranslateString('signatureName2')"
          :diplomaPaperNumber="student.diplomaPaperNumber"
          :student="student"
          v-if="curriculum"
        ></Table3Score>
      </template>
      <!-- <p
        style="font-family: Arial, sans-serif; position: absolute"
        :style="
          'top: ' +
          ui_setting.diplomPreTextY +
          'px;left: ' +
          ui_setting.diplomPreTextX +
          'pt;' +
          'font-size: ' +
          ui_setting.diplomTopicFontSize +
          'pt'
        "
      >
        <span>{{ _getTranslateString("diplomPreText") }}:</span>
        <span
          style="font-family: Arial, sans-serif; font-weight: bold !important"
        >
          {{ _getTranslateString("diplomWorkTitle") }}
        </span>
      </p> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Table3Score from "./Table3Score.vue";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  components: {},
  data: () => ({
    showLessonCode: false,

    curriculum: null,
    showDetails: false,
    allCreditPoints: null,
    allScore: 0,
    allCounter: 0,
    allCredit: 0,
    loading: true,
    yearScores: {},
    years: null,
    studentScores: null,
    value: "",
    nochange: true,
    name: null,
    description: null,
    signature: null,
    item: null,
  }),
  watch: {},
  props: {
    student: {
      required: true,
      type: Object,
    },
    ui_setting: {
      required: true,
      type: Object,
    },
    selectedLanguageType: {
      type: Object,
      required: true,
    },
  },
  components: {
    Table3Score,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    calculatedScoreTotal() {
      var xEnteredYear = 2019;
      var xCurrentYear = 2023;
      var sum = 0;
      if (this.yearScores) {
        for (var i = xEnteredYear; i <= xCurrentYear; i++) {
          var datas = this.yearScores[i + "-" + (i + 1 + "-1")];
          if (datas && datas.length > 0) {
            for (var k = 0; k < datas.length; k++) {
              if (datas[k].lesson && datas[k].lesson.credit) {
                sum = sum + parseFloat(datas[k].lesson.credit);
              }
            }
          }
        }
      }
      return sum;
    },
  },
  async created() {
    console.log(this.ui_setting);
    this.selectedLanguageType = { name: "1. Монгол xэл", languageType: 1 };
    this.student.xcurriculum.ref.onSnapshot((doc) => {
      let curriculum = doc.data();
      curriculum.id = doc.id;
      curriculum.ref = doc.ref;
      curriculum.lessons = null;
      curriculum.ref.collection("curriculums-lessons").onSnapshot((docs) => {
        curriculum.lessons = [];
        var counter = 0;
        docs.forEach((doc) => {
          counter++;
          let lesson = doc.data();
          lesson.id = doc.id;
          lesson.ref = doc.ref;
          lesson.index = counter;
          //lessonStandardRef
          lesson.lessonStandard.ref.onSnapshot((doc) => {
            let x = doc.data();
            x.id = doc.id;
            x.ref = doc.ref;
            lesson.lessonStandard = x;
          });
          curriculum.lessons.push(lesson);
        });
      });
      this.curriculum = curriculum;
    });

    var xEnteredYear = 2019;
    var xCurrentYear = 2023;
    for (var i = xEnteredYear; i <= xCurrentYear; i++) {
      this.yearScores[i + "-" + (i + 1) + "-" + 1] = [];
      this.yearScores[i + "-" + (i + 1) + "-" + 2] = [];
    }

    if (this.student.studentCode)
      await this._searchStudentScore1(this.student.studentCode);
  },
  mounted() {
    this.nochange = true;
  },
  watch: {
    name: function () {
      this.nochange = false;
    },
    description: function () {
      this.nochange = false;
    },
    signature: function () {
      this.nochange = false;
    },
  },
  methods: {
    _convertToMB(str) {
      if (str) {
        var oldStr = str.toString();
        var newStr = "";
        for (let i = 0; i < oldStr.length; i++) {
          newStr = newStr + this._convertHelper(oldStr[i]);
        }
        return newStr;
      } else {
        return "";
      }
    },
    _convertHelper(char) {
      switch (char) {
        case "1":
          return "᠑";
        case "2":
          return "᠒";
        case "3":
          return "᠓";
        case "4":
          return "᠔";
        case "5":
          return "᠕";
        case "6":
          return "᠖";
        case "7":
          return "᠗";
        case "8":
          return "᠘";
        case "9":
          return "᠙";
        case "0":
          return "᠐";
        default:
          return char;
      }
    },
    _getDiplomaDegreeText(text) {
      if (text == "bachelor")
        return text.charAt(0).toUpperCase() + text.slice(1) + "'s";
      else return text.charAt(0).toUpperCase() + text.slice(1);
    },
    _getTranslateTextLabel(keyword) {
      if (this.selectedLanguageType.languageType == 1)
        return this.ui_setting[keyword];
      else if (this.selectedLanguageType.languageType == 2)
        return this.ui_setting[keyword + "EN"];
      else if (this.selectedLanguageType.languageType == 3)
        return this.ui_setting[keyword + "MB"];
    },
    _getTranslateText(keyword) {
      if (this.selectedLanguageType.languageType == 1)
        return this.ui_setting[keyword];
      else if (this.selectedLanguageType.languageType == 2)
        return this.ui_setting[keyword + "EN"];
      else if (this.selectedLanguageType.languageType == 3)
        return this.ui_setting[keyword + "MB"];
    },
    _getTranslateString(keyword) {
      if (keyword == "firstName" && this.selectedLanguageType.languageType == 1)
        return this.student.firstName;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.student.firstNameEN;
      else if (
        keyword == "firstName" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.student.firstNameMB;
      if (keyword == "lastName" && this.selectedLanguageType.languageType == 1)
        return this.student.lastName;
      else if (
        keyword == "lastName" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.student.lastNameEN;
      else if (
        keyword == "lastName" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.student.lastNameMB;

      if (
        keyword == "diplomWorkTitle" &&
        this.selectedLanguageType.languageType == 1
      )
        return this.student.diplomWorkTitle;
      else if (
        keyword == "diplomWorkTitle" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.student.diplomWorkTitleEN;
      else if (
        keyword == "diplomWorkTitle" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.student.diplomWorkTitleMB;

      ///

      if (
        keyword == "diplomPreText" &&
        this.selectedLanguageType.languageType == 1
      )
        return this.ui_setting.diplomPreText;
      else if (
        keyword == "diplomPreText" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.ui_setting.diplomPreTextEN;
      else if (
        keyword == "diplomPreText" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.ui_setting.diplomPreTextMB;
      // signature
      else if (
        keyword == "signatureText1" &&
        this.selectedLanguageType.languageType == 1
      )
        return this.ui_setting.signatureText1;
      else if (
        keyword == "signatureText1" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.ui_setting.signatureText1EN;
      else if (
        keyword == "signatureText1" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.ui_setting.signatureText1MB;
      else if (
        keyword == "signatureText2" &&
        this.selectedLanguageType.languageType == 1
      )
        return this.ui_setting.signatureText2;
      else if (
        keyword == "signatureText2" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.ui_setting.signatureText2EN;
      else if (
        keyword == "signatureText2" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.ui_setting.signatureText2MB;
      //signature name
      else if (
        keyword == "signatureName1" &&
        this.selectedLanguageType.languageType == 1
      )
        return this.ui_setting.signatureName1;
      else if (
        keyword == "signatureName1" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.ui_setting.signatureName1EN;
      else if (
        keyword == "signatureName1" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.ui_setting.signatureName1MB;
      ///
      else if (
        keyword == "signatureName2" &&
        this.selectedLanguageType.languageType == 1
      )
        return this.ui_setting.signatureName2;
      else if (
        keyword == "signatureName2" &&
        this.selectedLanguageType.languageType == 2
      )
        return this.ui_setting.signatureName2EN;
      else if (
        keyword == "signatureName2" &&
        this.selectedLanguageType.languageType == 3
      )
        return this.ui_setting.signatureName2MB;
    },
    _confirmGPACalculation(allCreditPoints, allCredit) {
      console.log(this.student.ref.path, allCreditPoints, allCredit);

      var datas = {};

      if (allCredit > 0)
        datas._confirmed_calculated_GPA = parseFloat(
          (allCreditPoints / allCredit).toFixed(2)
        );

      datas["_confirmed_calculated_allCreditPoints"] = allCreditPoints;
      datas["_confirmed_calculated_allCredit"] = allCredit;
      datas["_confirmed_calculated_date"] = new Date();

      this.student.ref.update(datas).then(() => {
        console.log(this.student.ref.path, datas);
      });
    },
    _getYearTotalGPAPoints(yearScore) {
      var sum = 0;
      for (const xx of yearScore) {
        sum = sum + xx.gpaTotalPoint;
      }
      return parseFloat(sum);
    },
    _getYearTotalScoreAverageGPA(yearScore, sem) {
      var sum = 0;
      var zz = this._getYearTotalCredit(yearScore, sem);
      for (const xx of yearScore) {
        if (xx.semester == sem) {
          if (xx.lesson && xx.lesson.credit && xx.lesson.credit > 0) {
            sum =
              sum +
              parseFloat(this._getGPAPoint(xx.scoreTotal) * xx.lesson.credit);
          } else sum = sum + 0;
        }
      }
      if (zz > 0) return parseFloat(sum / zz).toFixed(1);
      else return 0;
    },
    _getYearTotalCredit(yearScore, sem) {
      var sum = 0;
      for (const xx of yearScore) {
        if (xx.semester == sem) {
          if (xx.lesson && xx.lesson.credit && xx.lesson.credit > 0) {
            sum = sum + parseFloat(xx.lesson.credit);
          } else sum = sum + 0;
        }
      }
      return sum;
    },

    calculatedScoreTotal2() {
      var xEnteredYear = 2019;
      var xCurrentYear = 2023;
      var sum = 0;
      if (this.yearScores) {
        for (var i = xEnteredYear; i <= xCurrentYear; i++) {
          var datas = this.yearScores[i + "-" + (i + 1 + "-1")];
          if (datas && datas.length > 0) {
            for (var k = 0; k < datas.length; k++) {
              if (datas[k].lesson && datas[k].lesson.credit) {
                sum = sum + parseFloat(datas[k].lesson.credit);
              }
            }
          }
        }
      }
      console.log(sum);
      return sum;
    },
    _getGPAString(score) {
      if (95 <= score && score <= 100) return "A+";
      else if (90 <= score && score <= 94) return "A";
      else if (87 <= score && score <= 89) return "B+";
      else if (80 <= score && score <= 86) return "B";
      else if (77 <= score && score <= 79) return "C+";
      else if (70 <= score && score <= 76) return "C";
      else if (60 <= score && score <= 69) return "D";
      else return "F,W,WF";
    },
    _getGPAPoint(score) {
      if (95 <= score && score <= 100) return 4;
      else if (90 <= score && score <= 94) return 3.7;
      else if (87 <= score && score <= 89) return 3.3;
      else if (83 <= score && score <= 86) return 3;
      else if (80 <= score && score <= 82) return 2.7;
      else if (77 <= score && score <= 79) return 2.3;
      else if (73 <= score && score <= 76) return 2;
      else if (70 <= score && score <= 72) return 1.7;
      else if (65 <= score && score <= 69) return 1.3;
      else if (60 <= score && score <= 64) return 1;
      else return 0;
    },
    _getScoreYear(str) {
      if (str) {
        var x = str.lastIndexOf("-");
        if (x > 0) return str.substring(0, x);
        else null;
      } else return str;
    },

    _getScoreSemester(str) {
      if (str) {
        var x = str.lastIndexOf("-");
        if (x > 0) return str.substring(x + 1);
        else null;
      } else return str;
    },
    _getScoreSemester2(score) {
      if (score.year) {
        var x = score.year.lastIndexOf("-");
        if (x > 0) return score.year.substring(x + 1);
        else null;
      } else return score.year;
    },
    _print() {
      const localOptions = {
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
          "./print.css",
        ],
      };
      this.$htmlToPaper("printMe", localOptions);
    },
    async _searchStudentScore1(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          this.studentScores = [];
          this.allCreditPoints = 0;
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            score.lesson = null;

            if (score.lessonCode) {
              var datas = await fb.db
                .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
                .where("code", "==", score.lessonCode)
                .limit(1)
                .get();
              if (!datas.empty) {
                var doc = datas.docs[0];
                if (doc != null && doc.exists) {
                  score.lesson = doc.data();
                }
              } else {
                var datas = await fb.db
                  .collection(
                    "/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/"
                  )
                  .where("code", "==", score.lessonCode.toUpperCase())
                  .limit(1)
                  .get();
                if (!datas.empty) {
                  var doc = datas.docs[0];
                  if (doc != null && doc.exists) {
                    score.lesson = doc.data();
                  }
                }
              }
            }
            if (!score.lesson.isDiplomLesson) {
              score.year = score.ref.parent.parent.id;
              if (score.semester) {
                score.semester = score.semester;
              } else {
                if (score.lessonRef) {
                  var tt = await score.lessonRef.get();
                  if (tt.data().semesterRef) {
                    var sem = await tt.data().semesterRef.get();
                    score.semester = sem.data().shortName == "Намар" ? 1 : 2;
                  } else {
                    score.semester = "NOS";
                  }
                } else {
                  //xTODO NOWAY TODO DANGEROUS
                  var dd = score.createdAt.toDate();
                  if (dd.getFullYear() == "2023" && dd.getMonth() + 1 < 2) {
                    score.semester = 1;
                  } else {
                    score.semester = "ERROR - ERROR";
                  }
                }
              }
              this.yearScores[score.ref.parent.parent.id].push(score);
              if (score.lesson && score.lesson.credit) {
                this.allCredit =
                  this.allCredit + parseFloat(score.lesson.credit);
              }
              this.allCounter++;
              this.allScore = this.allScore + score.scoreTotal;

              if (score.lesson && score.lesson.credit > 0) {
                this.allCreditPoints =
                  this.allCreditPoints +
                  parseFloat(
                    this._getGPAPoint(score.scoreTotal) * score.lesson.credit
                  );

                score.gpaTotalPoint = parseFloat(
                  this._getGPAPoint(score.scoreTotal) * score.lesson.credit
                );
              } else {
                fb.db
                  .collection("_errored_scores")
                  .doc()
                  .set({ link: score.ref.path })
                  .then(() => {
                    this.student.ref.update({ _errorScores: true });
                  });
              }
              console.log(
                score.lesson.name,
                score.lesson.code,
                score.scoreTotal
              );
              this.studentScores.push(score);
            } else {
              this.student.diplomaLessonScore = score;
            }
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
        });
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    margin: 0;
  }
}
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.a4-container {
  position: relative;
  width: 29.7cm;
  height: 21cm;
  border: 1px solid black;
  margin: 0 auto;
}
.a4-container .main-text {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  margin: 0 auto;
  box-sizing: border-box;
}

.a4-container .bottom-container {
  position: relative;
  bottom: 100px;
  display: flex;
  justify-content: space-between;
  height: 100px;

  padding-left: 40px;
  padding-right: 40px;
}

.a4-container .bottom-container .signature {
  border-top: 1px solid black;
  padding-top: 4px !important;
  margin-left: 30px;
  margin-right: 30px;
  width: 33%;
}
.signature .pclass {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.a4-container .head-score-page {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid black;
}

.a4-container .score-main {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid red;
}
.a4-container .head-score-page .title-column {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .head-score-page .title-column .column-text {
  text-align: left;
  padding: 2px;
  width: 50%;
  background-color: lightgray;
}
.a4-container .score-main .score-table-column {
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .score-signature-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid blue;
}
.a4-container .score-signature-container .score-signature {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 40%;
  background-color: lightgray;
}
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid black;
  padding: 8px;
}
.title-column .upper {
  text-transform: uppercase;
  font-weight: bold;
}
</style>
